import { SortDef } from '@/components/shared/filters';
import { DefaultSort } from '@/components/shared/filters';

/**
 * Accounts sort registry. URL params map straight onto the `/accounts/`
 * endpoint query params: sort_by, sort_order. The stage filter is built
 * in-component (options are org-dynamic — see lifecycleStages.tsx).
 */
export const ACCOUNTS_SORTS: SortDef[] = [
  { id: 'last_activity_at', label: 'Last Activity', field: 'last_activity_at', defaultOrder: 'desc' },
  { id: 'name', label: 'Name', field: 'name', defaultOrder: 'asc' },
  { id: 'domain', label: 'Domain', field: 'domain', defaultOrder: 'asc' },
  { id: 'stage', label: 'Stage', field: 'stage', defaultOrder: 'asc' },
  { id: 'lead_count', label: 'Contacts', field: 'lead_count', defaultOrder: 'desc' },
  { id: 'visitor_count', label: 'Visitors', field: 'visitor_count', defaultOrder: 'desc' },
  { id: 'fit_score', label: 'Fit Score', field: 'fit_score', defaultOrder: 'desc' },
  { id: 'first_confirmed_at', label: 'Confirmed', field: 'first_confirmed_at', defaultOrder: 'desc' },
  { id: 'created_at', label: 'Date Created', field: 'created_at', defaultOrder: 'desc' },
];

export const ACCOUNTS_DEFAULT_SORT: DefaultSort = { field: 'last_activity_at', order: 'desc' };
